import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const MostUsedTechnologies: React.FC = () => {
  const data = [
    { language: 'CSS', value: 13.751430205949658, fill: '#08306B' },
    { language: 'React', value: 11.806350114416476, fill: '#08306B' },
    { language: 'MySQL', value: 11.799199084668192, fill: '#08519C' },
    { language: 'HTML', value: 11.613272311212814, fill: '#08519C' },
    { language: 'Git', value: 10.948226544622425, fill: '#2171B5' },
    { language: 'Docker', value: 8.724256292906178, fill: '#2171B5' },
    { language: 'SQL', value: 8.531178489702517, fill: '#4292C6' },
    { language: 'NodeJS', value: 8.445366132723112, fill: '#4292C6' },
    { language: 'MongoDB', value: 7.73741418764302, fill: '#6BAED6' },
    { language: 'AWS', value: 6.643306636155606, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts className="dark">
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
            />
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default MostUsedTechnologies;
